import xhr from 'Common/utils/xhr'

const url = `/api/v1/flashcard_sets`

function getFlashcardSets() {
  return xhr({
    url,
    method: 'GET',
  })
}

/**
 * Create a new flashcard set
 * @param {object} config
 * @param {string} [config.name = null] - The name of the new set; endpoint returns 'Untitled Flashcard Set' by default
 * @param {string} [config.description = null] - The set description; endpoint returns null by default
 */
function createFlashcardSet({ name = null, description = null } = {}) {
  return xhr({
    url,
    method: 'POST',
    data: {
      flashcard_set: {
        name,
        description,
      },
    },
  })
}

function updateFlashcardSet({ name, description, id } = {}) {
  return xhr({
    url: `${url}/${id}`,
    method: 'PUT',
    data: {
      flashcard_set: {
        name,
        description,
      },
    },
  })
}

function deleteFlashcardSet({ id }) {
  return xhr({
    url: `${url}/${id}`,
    method: 'DELETE',
  })
}

function duplicateFlashcardSet({ id } = {}) {
  return xhr({
    url: `${url}/${id}/copy`,
    method: 'POST',
  })
}

/**
 * Save a given set of flashcards to one or more flashcard sets
 * @param {object} config
 * @param {number[]} config.setIds - array of user's flashcard set IDs to save the flashcards to
 * @param {object[]} config.flashcards - array of the flashcards to save to indicated sets
 * @param {string} config.flashcards[].title - the default title of the flashcard
 * @param {string} [config.flashcards[].userTitle] - user's custom title for the flashcard
 * @param {number} config.flashcards[].id - the flashcard's id
 */
function createUserFlashcards({ setIds, flashcards }) {
  return Promise.all(
    setIds.map(setId =>
      xhr({
        url: `${url}/${setId}/user_flashcards`,
        method: 'POST',
        data: {
          user_flashcards: flashcards.map(fc => ({
            image_title: fc.userTitle || fc.title,
            flashcard_id: fc.id,
          })),
        },
      })
    )
  )
}

export default {
  getFlashcardSets,
  createFlashcardSet,
  updateFlashcardSet,
  deleteFlashcardSet,
  duplicateFlashcardSet,
  createUserFlashcards,
}
